var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 13,
  viewBox: "0 0 14 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#528AEA",
  fillRule: "evenodd",
  d: "M14.021 6.73a.317.317 0 0 0-.194-.293L.54.83a.32.32 0 0 0-.426.403l1.671 4.664 4.578.692c.18.028.18.288 0 .316l-4.582.71-1.69 4.672a.318.318 0 0 0 .075.333l.006.007c.092.086.227.11.343.06l13.311-5.662a.32.32 0 0 0 .195-.294z"
})));
export default __webpack_public_path__ + "teg/media/sendIcon.125b2d39.svg";
export { SvgComponent as ReactComponent };